module.exports = __webpack_public_path__ + "images/feature/inbox-img1-d766e87d88291c947573ae22dee1d140.png";